import { SyncParams } from '../../shared-solo/lib/calendarSyncHelper'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const autoSyncBookingWithCalendar = async (params: SyncParams) => {
  // const permission = await RNCalendarEvents.checkPermissions()
  // if (permission != 'authorized') {
  return false
  // }
  // return syncBookingWithCalendar(booking, store, showDropdown)
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const autoRemoveBookingFromCalendar = async (params: SyncParams) => {
  // const permission = await RNCalendarEvents.checkPermissions()
  // if (permission != 'authorized') {
  return false
  // }
}
